/* @flow */

import { buildVirtualBraindateEarlyReminder } from 'plugin/virtual-braindate/util/virtualBraindateUtils';
import { queueNotification } from 'src/shared/app/notification/action/uiNotificationActions';

import type { Braindate } from '@braindate/domain/lib/braindate/type';

export function showVirtualBraindateEarlyReminder(braindate: Braindate) {
  return queueNotification(
    buildVirtualBraindateEarlyReminder((braindate: Braindate)),
  );
}
